module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-slides-81b221a9.svg";